export default {
  install(app) {
    const dashly = {
      inited: false,
      openChat() {
        window.dashly.open()
      },
      async init(dashlySettings) {
        if (!this.inited) {
          await this.loadScript(dashlySettings)
          this.inited = true
        }
        window.dashly.auth(dashlySettings.userId, dashlySettings.userHash)
      },
      loadScript({ apiKey }) {
        return new Promise((resolve) => {
          function t(value) {
            return function () {
              window.dashlyasync.push(value, arguments)
            }
          }
          if (typeof window.dashly === 'undefined') {
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.async = true
            script.src = 'https://cdn.dashly.app/api.min.js'
            document.getElementsByTagName('head')[0].appendChild(script)
            window.dashly = {}
            window.dashlyasync = []
            window.dashly.settings = {}
            for (
              let n = [
                  'connect',
                  'track',
                  'identify',
                  'auth',
                  'onReady',
                  'addCallback',
                  'removeCallback',
                  'trackMessageInteraction'
                ],
                a = 0;
              a < n.length;
              a += 1
            )
              window.dashly[n[a]] = t(n[a])
          }
          window.dashly.connect(apiKey)
          resolve()
        })
      }
    }

    app.config.globalProperties.$dashly = dashly
    app.provide('dashly', dashly)
  }
}
